module.exports = __webpack_public_path__ + "static/media/4-4.868f8c63.mp3";